export const FOUR_HOURS_MINUTES = 240;
export const HALF_HOUR_MINUTES = 30;

export const HALF_HOUR_LOOP_LIMIT = 48;
export const FOUR_HOURS_LOOP_LIMIT = 6;
